import React, { useEffect, useRef } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const ChartDoughnut = ({ centerText, configData, size }) => {
  const chartRef = useRef(null);

  const labels = configData?.map((item) => item.label);
  const dataValues = configData?.map((item) => item.data);
  const backgroundColors = configData?.map((item) => item.backgroundColor);

  const data = {
    labels: [...labels],
    datasets: [
      {
        label: "",
        data: [...dataValues],
        backgroundColor: [...backgroundColors],
      },
    ],
  };

  const options = {
    animation: false,
    cutout: "" + (100 - size),
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const textPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const width = chart.width;
      const height = chart.height;
      const ctx = chart.ctx;

      ctx.restore();
      ctx.font = "16px Arial";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#868686";

      const text = centerText;

      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.clearRect(0, 0, width, height);
      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
  }, [centerText, configData]);

  return <Doughnut ref={chartRef} data={data} options={options} plugins={[textPlugin]} />;
};

export default ChartDoughnut;
